
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/multimedia",
      function () {
        return require("private-next-pages/multimedia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/multimedia"])
      });
    }
  